
export const DEFAULT_LANGUAGE = 'es';

export const LOCALE = 'es-MX';

export const DATE_FORMAT = 'YYYY-MM-DD';

export const DATE_FORMAT_UNDER = 'YYYY_MM_DD';

export const DATE_FORMAT_SS = 'YYYY-MM-DD HH:mm:ss';

export const DATE_FORMAT_LL = 'MMMM D, YYYY';

export const DATE_FORMAT_SS_ES = 'DD/MM/YYYY; HH:mm:ss';

export const DATE_FORMAT_DD = 'ddd DD';

export const DATE_INPUT = 'YYYY-MM-DDThh:mm:ss';

export const DEFAULT_PAGE_SIZE_TABLE = 10;

export const DEFAULT_PAGE_INIT_TABLE = 1;

export const DEFAULT_PAGE_INIT_TABLE_FILTER = 0;

export const DEFAULT_OPTIONS_PAGES_TABLE = [1, 5, 10, 25, 100];

export const DEFAULT_ROTE_IMG_NOTFOUND = '/assets/img/avatar.png';
export const DEFAULT_ROTE_IMG_NOTFOUND_CAR = '/assets/img/Placeholder.svg';

export const DEFAULT_DISTANCE_POLYGON_CAMERAS = 800;
export const NUMBER_POSITIVE = /^[0-9]+$/;
export const CAPITAL_LETTER =
    /^(?=(?:.*[A-Z]{1}))(?=(?:.*[a-z]{1}))(?=(?:.*[0-9]{1}))/;

export const user_data_id_key = 'PDUSR#';
export const PASSWORD_FORMAT =
    /^(?=(?:.*[A-Z]{1}))(?=(?:.*[@$?¡\-_+!#%<>]){1})(?=(?:.*[0-9]{1}))/;

export const CURP_REGEX = /^([A-Z][AEIOUX][A-Z]{2}\d{2}(?:0[1-9]|1[0-2])(?:0[1-9]|[12]\d|3[01])[HM](?:AS|B[CS]|C[CLMSH]|D[FG]|G[TR]|HG|JC|M[CNS]|N[ETL]|OC|PL|Q[TR]|S[PLR]|T[CSL]|VZ|YN|ZS)[B-DF-HJ-NP-TV-Z]{3}[A-Z\d])(\d)$/;

export const RFC_REGEX = /^([A-Z,Ñ,&]{3,4}([0-9]{2})(0[1-9]|1[0-2])(0[1-9]|1[0-9]|2[0-9]|3[0-1])[A-Z|\d]{3})$/;

export const EMAIL_REGEX = /^(([^<>()\[\]\\.,;:\s@']+(\.[^<>()\[\]\\.,;:\s@']+)*)|('.+'))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

export const DEFAULT_PUNTER_CAM_POSITION_MAP = '../assets/svg/selectMaps.svg';
export const DEFAULT_PUNTER_POSITION_MAP_EVENT = '../assets/svg/pin.svg';
export const DEFAULT_PUNTER_POSITION_MAP_EVENTT = '../assets/svg/automovil.png';
export const DEFAULT_PUNTER_POSITION_MAP_POLICE = '../assets/svg/police-iconpatrullaMarker.svg';
export const DEFAULT_PUNTER_POSITION_MAP_PINCAMERACALL = '../assets/svg/pinpincamera.svg';
export const DEFAULT_MAP_OPTIONS = {
    center: { lat: 19.698632, lng: -101.197887 },
    panControl: false,
    disableDefaultUI: true,
    zoomControl: true,
    zoom: 13,
    styles: [
        {
            featureType: 'administrative',
            elementType: 'geometry',
            stylers: [
                {
                    'visibility': 'off'
                }
            ]
        },
        {
            featureType: 'poi',
            stylers: [
                {
                    'visibility': 'off'
                }
            ]
        },
        {
            featureType: 'road',
            elementType: 'labels.icon',
            stylers: [
                {
                    'visibility': 'off'
                }
            ]
        }
    ],
};

export const DEFAULT_MAP_OPTIONSDemo = {
    center: { lat: 19.698632, lng: -101.197887 },
    panControl: false,
    disableDefaultUI: true,
    zoomControl: true,
    scrollwheel: false,
    zoom: 13,
    styles: [
        {
            featureType: 'administrative',
            elementType: 'geometry',
            stylers: [
                {
                    'visibility': 'off'
                }
            ]
        },
        {
            featureType: 'poi',
            stylers: [
                {
                    'visibility': 'off'
                }
            ]
        },
        {
            featureType: 'road',
            elementType: 'labels.icon',
            stylers: [
                {
                    'visibility': 'off'
                }
            ]
        }
    ],
};

export const HARDCOR_POSITION_CAMS = [
    {
        lat: 20.6755394,
        lng: -103.3829163
    }
];

export type bodyDatalistInputWeaponsDevicesArmonyType = {
    checkValue: string
    key: string
    devices: string
    assigned: string
}[];
export const bodyDatalistInputWeaponsDevicesArmony = Object.freeze([
    // {
    //     'checkValue': 'true',
    //     'key': 'body_cam_out',
    //     'devices': 'BodyCam',
    //     'assigned': ''
    // },
    Object.freeze({
        'checkValue': 'true',
        'key': 'gun_short_out',
        'devices': 'Arma corta',
        'assigned': ''
    }),
    Object.freeze({
        'checkValue': 'true',
        'key': 'gun_large_out',
        'devices': 'Arma larga',
        'assigned': ''
    }),
    // {
    //     'checkValue': 'true',
    //     'key': 'radio_out',
    //     'devices': 'Radio',
    //     'assigned': ''
    // }
]);

export const bodyDatalistOutputWeaponsDevicesArmony = Object.freeze([
    // {
    //     id: '13',
    //     key: 'body_cam_in',
    //     devices: 'BodyCam',
    //     valueQr: '',
    //     assigned: '',
    //     actions: [
    //         {
    //             key: 'delete',
    //             icon: 'ic-trash',
    //         },
    //     ]
    // },
    Object.freeze({
        id: '2',
        key: 'gun_short_in',
        devices: 'Arma corta',
        valueQr: '',
        assigned: '',
        actions: [
            {
                key: 'delete',
                icon: 'ic-trash',
            },
        ]
    }),
    Object.freeze({
        id: '11',
        key: 'gun_large_in',
        devices: 'Arma larga',
        valueQr: '',
        assigned: '',
        actions: [
            {
                key: 'delete',
                icon: 'ic-trash',
            },
        ]
    }),
    // {
    //     id: '12',
    //     key: 'radio_in',
    //     devices: 'Radio',
    //     valueQr: '',
    //     assigned: '',
    //     actions: [
    //         {
    //             key: 'delete',
    //             icon: 'ic-trash',
    //         },
    //     ]
    // }
]);

export const typeHearigns = [
    {
        spa: 'Tránsito',
        eng: 'TRAFFIC'
    },
    {
        spa: 'Orden NGC',
        eng: 'NGC'
    },
    {
        spa: 'Alcoholímetro',
        eng: 'BREATHALYZE'
    },
    {
        spa: 'Orden',
        eng: 'ORDER'
    }
];

export const DISTRESSCALL_STATUS = [
    { id: 1, value: 'Recibida' },
    { id: 2, value: 'Despachada' },
    { id: 3, value: 'Llegada de unidad' },
    { id: 4, value: 'Finalizada' }
];

export const POLICE_GENERAL_TABS = [
    { name: 'POLICE.GENERAL.InformationCards' },
    { name: 'POLICE.GENERAL.incidents' },
    { name: 'POLICE.GENERAL.cdm' },
    { name: 'POLICE.GENERAL.madeAvailable' },
    { name: 'POLICE.GENERAL.detailedView' }
];

export const MODULES_URLS = [
    { url: 'perfil', idMenu: 0, title: 'Perfil' },
    { url: 'panel', idMenu: 1, title: 'Reporte de eventos' },
    { url: 'usuarios', idMenu: 2, title: 'Usuarios' },
    { url: 'tipo-usuarios', idMenu: 3, title: 'Tipos de usuario' },
    { url: 'policias', idMenu: 5, title: 'Policías' },
    { url: 'permisos', idMenu: 6, title: 'Permisos' },
    { url: 'eventos', idMenu: 7, title: 'Eventos' },
    { url: 'unidad-patrullaje', idMenu: 8, title: 'Unidad de patrullaje' },
    { url: 'empleados', idMenu: 9, title: 'Empleados' },
    { url: 'unidades-asignadas', idMenu: 10, title: 'Unidades asignadas' },
    { url: 'variables-sistema', idMenu: 11, title: 'Variables del sistema' },
    { url: 'administracion-catalogos', idMenu: 12, title: 'Administración de catálogos' },
    { url: 'inventario', idMenu: 13, title: 'Inventarios' },
    { url: 'smart-pss', idMenu: 14, title: 'Gestión de cámaras' },
    { url: 'check-in', idMenu: 15, title: 'Gestión de Check In' },
    // { url: 'siagem', idMenu: 16, title: 'SIAGEM' },
    { url: 'asistencia/check-in', idMenu: 17, title: 'Asistencia' },
    { url: 'armeria', idMenu: 18, title: 'Armería' },
    { url: 'iph', idMenu: 19, title: 'Informe Policial Homologado (IPH)' },
    { url: 'conciliacion', idMenu: 20, title: 'Conciliación' },
    { url: 'certificacion-medica', idMenu: 21, title: 'Certificaciones médicas' },
    { url: 'audiencias/orden', idMenu: 22, title: 'Audiencias de Orden' },
    { url: 'control-plazas', idMenu: 23, title: 'Control de plazas' },
    { url: 'consultations-tfc-management', idMenu: 24, title: 'Gestión TFC' },
    { url: 'audiencias/transito', idMenu: 25, title: 'Audiencias de tránsito' },
    { url: 'audiencias/alcoholimetro', idMenu: 26, title: 'Audiencias de alcoholimetro' },
    { url: 'audiencias/orden-ngc', idMenu: 27, title: 'Audiencias de orden ngc' },
    { url: 'violaciones/transito', idMenu: 28, title: 'Infracciones de tránsito' },
    { url: 'infacciones/breathalyser', idMenu: 29, title: 'Infracciones alcoholímetro' },
    { url: 'violaciones/orden/ngc', idMenu: 30, title: 'Infracciones Orden NGC' },
    { url: 'historico-movimientos-empleados', idMenu: 31, title: 'Histórico de movimientos de empleado' },
    { url: 'seguimientogps', idMenu: 32, title: 'Seguimiento de unidades' },
    { url: '/detenidos', idMenu: 33, title: 'Detenciones' },
    { url: 'llamadas/auxilio', idMenu: 34, title: 'Llamadas auxilio' },
    { url: 'tamizaje', idMenu: 35, title: 'Tamizaje' },
    { url: 'asistencia/check-out', idMenu: 36, title: 'Salida' },
    // { url: '/check-out', idMenu: 37, title: 'Gestión de Check Out' },
    { url: 'detenidos/historico', idMenu: 38, title: 'Histórico de detenciones' },
    { url: 'armeria/control', idMenu: 39, title: 'Control de salidas de armas o dispositivos (Entregas a policía)' },
    { url: 'resumen-audiencias', idMenu: 40, title: 'Resumen audiencias' },
    { url: 'denuncias', idMenu: 41, title: 'Denuncias' },
    { url: 'consultations-tfc-management/orden', idMenu: 42, title: 'Gestión TFC Orden' },
    { url: 'consultations-tfc-management/transito', idMenu: 43, title: 'Gestión TFC Tránsito' },
    { url: 'consultations-tfc-management/alcoholimetro', idMenu: 44, title: 'Gestión TFC Alcoholímetro' },
    { url: 'consultations-tfc-management/orden-ngc', idMenu: 45, title: 'Gestión TFC Orden NGC' },
    { url: 'detenidos/salidas-pendientes', idMenu: 46, title: 'Salidas pendientes' },
    { url: 'estado-de-fuerza', idMenu: 47, title: 'Estado de fuerza' },
    { url: 'asuntos-internos', idMenu: 48, title: 'Asuntos internos' },
    { url: 'resumen', idMenu: 49, title: 'Resumen' },
    { url: 'policia-municipal', idMenu: 50, title: 'Policía municipal' },
    { url: 'fiscalia-estatal', idMenu: 51, title: 'Fiscalía estatal' },
    { url: 'ssp', idMenu: 52, title: 'SSP Secretaria Seguridad Pública del estado' },
    { url: 'consejo-honor-y-justicia', idMenu: 53, title: 'Consejo Honor y justicia' },
    { url: 'cursos', idMenu: 54, title: 'Cursos de empleados' },
    { url: 'estadisticas', idMenu: 55, title: 'Estadísticas' },
    // { url: 'repuve/extranjeros', idMenu: 56, title: 'REPUVE / Extranjeros' },
    { url: 'repuve/extranjeros', idMenu: 56, title: 'REPUVE / SCT' },
    { url: 'comisionados', idMenu: 57, title: 'Comisionados' },
    { url: 'repuve/nacionales', idMenu: 58, title: 'REPUVE / Nacionales' },
];

export const MODALITIES = [
    { id: 1, value: 'DISTRESSCALL.violence' },
    { id: 2, value: 'DISTRESSCALL.noViolence' },
    { id: 3, value: 'DISTRESSCALL.noSpecify' }
];

export const SISTEM_VARIABLE = 'e9e62482-9cfc-43ac-bc40-fd9c55992bdd';

export const DISTINCTIONS_ARR = [
    'Sector',
    'Agrupamiento',
    'Área Administrativa'
];

export const GENDER_ARR = [
    { id: 1, value: 'Femenino' },
    { id: 2, value: 'Masculino' },
    { id: 3, value: 'N.A' }
];

export const TRAFFIC_HEARING_STATUS_ARR = [
    { value: true, viewValue: 'Finalizado' },
    { value: false, viewValue: 'En proceso' }
];

export const ERROR_CHECKIN_CODES: any = {
    'Formato de QR incorrecto': 'errorQrCheckin',
    'Policía inactivo': 'errorInactiveCheckin',
    'Aun no puedes pasar Asistencia': 'errorTimeCheckin',
    'Tienes ya registrado un Check In': 'errorTimeCheckin',
    '': 'errorQrCheckin',
};

export const TYPE_CHECKIN_DALOGS: any = {
    successCheckin: {
        title: 'PRESENCECHECKIN.titleAlertSuccesCheckin',
        message: 'PRESENCECHECKIN.messageAlertSuccesCheckin',
        type: 'success',
    },
    errorQrCheckin: {
        title: 'PRESENCECHECKIN.titleAlertErrorQrCheckin',
        message: 'PRESENCECHECKIN.messageAlertErrorQrCheckin',
        type: 'warning',
    },
    errorTimeCheckin: {
        title: 'PRESENCECHECKIN.tittleAlertErrorTimeCheckin',
        message: 'PRESENCECHECKIN.messageAlertErrorTimeCheckin',
        type: 'warning',
    },
    errorInactiveCheckin: {
        title: 'PRESENCECHECKIN.tittleAlertErrorInactiveCheckin',
        message: 'PRESENCECHECKIN.messageAlertErrorInactiveCheckin',
        type: 'warning',
    },
    selectTurnWarning: {
        title: 'PRESENCECHECKIN.tittleAlertErrorSelectTurn',
        message: 'PRESENCECHECKIN.messageAlertErrorSelectTurn',
        type: 'warning',
    },
};

export const TYPE_CHECKOUT_DALOGS: any = {
    successCheckout: {
        title: 'PRESENCECHECKIN.titleAlertSuccesCheckout',
        message: 'PRESENCECHECKIN.messageAlertSuccesCheckout',
        type: 'success',
    },
    errorQrCheckout: {
        title: 'PRESENCECHECKIN.titleAlertErrorQrCheckout',
        message: 'PRESENCECHECKIN.messageAlertErrorQrCheckout',
        type: 'warning',
    },
    errorInactiveCheckout: {
        title: 'PRESENCECHECKIN.tittleAlertErrorInactiveCheckin',
        message: 'PRESENCECHECKIN.messageAlertErrorInactiveCheckin',
        type: 'warning',
    },
    errorBlockedCheckout: {
        title: 'PRESENCECHECKIN.tittleAlertErrorTimeCheckout',
        message: 'PRESENCECHECKIN.messageAlertErrorTimeCheckout',
        type: 'warning',
    },
    errorBeforeCheckout: {
        title: 'PRESENCECHECKIN.tittleAlertErrorBeforeCheckout',
        message: 'PRESENCECHECKIN.messageAlertErrorBeforeCheckout',
        type: 'warning',
    },
};

export const ERROR_CHECKOUT_CODES: any = {
    'Formato de QR incorrecto': 'errorQrCheckout',
    'Policía inactivo': 'errorInactiveCheckout',
    'Tienes ya registrado un Check Out': 'errorBeforeCheckout',
    'No puedes registrar salida': 'errorBlockedCheckout',
    '': 'errorBlockedCheckout',
};

export const DEVICES = [
    { id: 1, value: 'Radio' },
    { id: 2, value: 'Bodycam' },
    { id: 3, value: 'Arma corta' },
    { id: 4, value: 'Arma larga' }
];

export const DEVICES_STATUS = [
    'Pendiente',
    'Entregado'
];

export const HEARING_TYPES: any = {
    'TRAFFIC': 'Tránsito',
    'BREATHALYZE': 'Alcoholímetro',
    'NGC': 'Orden NGC',
    'ORDER': 'Orden'
};

export const HEARING_TYPES_URLS: any = {
    'TRAFFIC': 'transito',
    'BREATHALYZE': 'alcoholimetro',
    'NGC': 'orden-ngc',
    'ORDER': 'orden'
};

export const realtionshipList: { value: string }[] = [
    { value: 'Madre' },
    { value: 'Padre' },
    { value: 'Hermano' },
    { value: 'Hijo' },
];

export const statusList: { value: string }[] = [
    { value: 'Detenido' },
    { value: 'Liberado' },
];

export const COMPLIANCE_CAT = [
    'Seguimiento',
    'Cumplió',
    'No cumplió'
];

export const QR_SPECIAL_CHARACTERS = [']]', '||', 'ÇÇ'];

export const JOB_CHANGE_REASONS = [
    'PLAZA VACANTE',
    'CAMBIO DE ADSCRIPCION - TRANSFIRIENDO PLAZA Y RECURSO'
];

export const conciliationsHeadersTable = [
    'employee_number',
    'full_name',
    'entry_date',
    'entry_hours',
    'exit_hours',
    'is_exist_system',
    'serial_number1',
    'exit_hour_armory1',
    'entry_hour_armory1',
    'serial_number2',
    'exit_hour_armory2',
    'entry_hour_armory2',
    'serial_number3',
    'exit_hour_armory3',
    'entry_hour_armory3',
    'serial_number4',
    'exit_hour_armory4',
    'entry_hour_armory4'
];

export const BG_CHANNELING = [
    'Terapéutico', 'Reeducativo'
];

export const TFC_SUGGEST = [
    'Terapéutico', 'Reeducativo', 'No apto para TFC'
];

export const SEVERITY_A = ['UMA & TFC'];

export const SEVERITY_BC = ['UMA & Hrs Arresto', 'TFC'];

export const SEVERITY_TYPE = {
    A: {
        fields: ['umas', 'tfc'],
        umas: '5-20',
        tfc: '24-36'
    },
    B: {
        fields: ['umas', 'arrest_hours'],
        umas: '5-40',
        arrest_hours: '24-40'
    },
    C: {
        fields: ['umas', 'arrest_hours'],
        umas: '5-60',
        arrest_hours: '24-36'
    }
};

export const GENERAL_COLORS = [
    { name: 'Policía municipal', color: '#4A74E7' },
    { name: 'Fiscalía', color: '#2938A4' },
    { name: 'SSP', color: '#17213C' }
];

export const ALL_COLORS = [
    '#4A74E7', '#2938A4', '#17213C', '#FF5733', '#33FF57', '#5733FF', '#FFC300',
    '#FF33A6', '#33FFF3', '#C70039', '#900C3F', '#581845', '#DAF7A6', '#FFC300'
];

export const YES_NO_CAT = [
    { value: true, label: 'Si' },
    { value: false, label: 'No' }
];

export const REPUVE_VEHICLE_TYPES = [
    'Sedán',
    'SUV',
    'Pickup',
    'Camión'
];

export const REPUVE_FUEL_TYPES = [
    'Gasolina',
    'Diesel',
    'Eléctrico',
];

export enum REPUVE_STATUS_ENUM {
    PENDING = 1,
    APPROVED = 2,
    REJECTED = 3,
}

export const REPUVE_STATUS = [
    {
        id: REPUVE_STATUS_ENUM.PENDING,
        name: 'Pendiente'
    },
    {
        id: REPUVE_STATUS_ENUM.APPROVED,
        name: 'Aprobado'
    },
    {
        id: REPUVE_STATUS_ENUM.REJECTED,
        name: 'Rechazado'
    }
]

export const REPUVE_MODULES = [
    {
        id: 1,
        name: 'ZACATECAS ZAC-01'
    },
    {
        id: 2,
        name: 'FRESNILLO ZAC-10'
    },
    {
        id: 3,
        name: 'POZO DE GAMBOA ZAC-11'
    },
    {
        id: 4,
        name: 'JALPA ZAC-12'
    },
    {
        id: 5,
        name: 'LORETO ZAC-13'
    },
    {
        id: 6,
        name: 'JEREZ ZAC-14'
    },
    {
        id: 7,
        name: 'TLALTENANGO ZAC-15'
    },
    {
        id: 8,
        name: 'PINOS ZAC-17'
    },
    {
        id: 9,
        name: 'VILLANUEVA ZAC-18'
    },
    {
        id: 10,
        name: 'LUIS MOYA ZAC-20'
    },
    {
        id: 11,
        name: 'SOMBRERETE ZAC-21'
    },
    {
        id: 12,
        name: 'CALERA ZAC-22'
    },
    {
        id: 13,
        name: 'MIGUEL AUZA ZAC-23'
    },
    {
        id: 14,
        name: 'CONCEPCION DEL ORO ZAC-24'
    },
    // {
    //     id: 15,
    //     name: 'Módulo número 15'
    // },
];

export enum REPUVE_POSITIONS_ENUM {
    ADMIN = 'Administrador',
    MANAGER = 'Gerente',
    CAPTURER = 'Capturista'
}

export const MUNICIPALITIES_LOCAL = [
    {
        logo: 'logos/apozol.jpeg',
        total: 15,
        c3: 9,
        cup: 3,
        subdomain: 'http://apozol.localhost:4200',
        municipality: 'Apozol',
        total_active: 0
    },
    {
        logo: 'logos/apulco.jpeg',
        total: 0,
        c3: 0,
        cup: 0,
        subdomain: 'http://apulco.localhost:4200',
        municipality: 'Apulco',
        total_active: 0
    },
    {
        logo: 'logos/atolinga.jpeg',
        total: 5,
        c3: 5,
        cup: 0,
        subdomain: 'http://atolinga.localhost:4200',
        municipality: 'Atolinga',
        total_active: 0
    },
    {
        logo: 'logos/benitojuarez.jpeg',
        total: 4,
        c3: 1,
        cup: 0,
        subdomain: 'http://benitojuarez.localhost:4200',
        municipality: 'Benito Juárez',
        total_active: 0
    },
    {
        logo: 'logos/calera.png',
        total: 35,
        c3: 25,
        cup: 14,
        subdomain: 'http://calera.localhost:4200',
        municipality: 'Calera',
        total_active: 0
    },
    {
        logo: 'logos/canitasfelipe.jpg',
        total: 12,
        c3: 2,
        cup: 0,
        subdomain: 'http://canitasfelipe.localhost:4200',
        municipality: 'Cañitas de Felipe Pescador',
        total_active: 0
    },
    {
        logo: 'logos/chalchihuites.jpeg',
        total: 8,
        c3: 7,
        cup: 0,
        subdomain: 'http://chalchihuites.localhost:4200',
        municipality: 'Chalchihuites',
        total_active: 0
    },
    {
        logo: 'logos/concepcionoro.jpg',
        total: 16,
        c3: 16,
        cup: 4,
        subdomain: 'http://concepcionoro.localhost:4200',
        municipality: 'Concepción del Oro',
        total_active: 0
    },
    {
        logo: 'logos/cuauhtemoc.png',
        total: 0,
        c3: 0,
        cup: 0,
        subdomain: 'http://cuauhtemoc.localhost:4200',
        municipality: 'Cuauhtémoc',
        total_active: 0
    },
    {
        logo: 'logos/plateadojoaquin.jpeg',
        total: 1,
        c3: 0,
        cup: 0,
        subdomain: 'http://plateadojoaquin.localhost:4200',
        municipality: 'El Plateado de Joaquín Amaro',
        total_active: 0
    },
    {
        logo: null,
        total: 7,
        c3: 2,
        cup: 0,
        subdomain: 'http://salvador.localhost:4200',
        municipality: 'El Salvador',
        total_active: 0
    },
    {
        logo: 'logos/fresnillo.png',
        total: 113,
        c3: 84,
        cup: 41,
        subdomain: 'http://fresnillo.localhost:4200',
        municipality: 'Fresnillo',
        total_active: 0
    },
    {
        logo: null,
        total: 4,
        c3: 3,
        cup: 1,
        subdomain: 'http://genarocodina.localhost:4200',
        municipality: 'Genaro Codina',
        total_active: 0
    },
    {
        logo: null,
        total: 11,
        c3: 7,
        cup: 2,
        subdomain: 'http://enriqueestrada.localhost:4200',
        municipality: 'General Enrique Estrada',
        total_active: 0
    },
    {
        logo: null,
        total: 20,
        c3: 6,
        cup: 1,
        subdomain: 'http://franciscomurguia.localhost:4200',
        municipality: 'General Francisco R. Murguía',
        total_active: 0
    },
    {
        logo: null,
        total: 17,
        c3: 7,
        cup: 1,
        subdomain: 'http://panfilonatera.localhost:4200',
        municipality: 'General Pánfilo Natera',
        total_active: 0
    },
    {
        logo: 'logos/guadalupe.png',
        total: 184,
        c3: 172,
        cup: 135,
        subdomain: 'http://guadalupe.localhost:4200',
        municipality: 'Guadalupe',
        total_active: 0
    },
    {
        logo: null,
        total: 4,
        c3: 4,
        cup: 2,
        subdomain: 'http://huanusco.localhost:4200',
        municipality: 'Huanusco',
        total_active: 0
    },
    {
        logo: null,
        total: 18,
        c3: 18,
        cup: 11,
        subdomain: 'http://jalpa.localhost:4200',
        municipality: 'Jalpa',
        total_active: 0
    },
    {
        logo: 'logos/jerez.png',
        total: 71,
        c3: 63,
        cup: 27,
        subdomain: 'http://jerez.localhost:4200',
        municipality: 'Jerez',
        total_active: 0
    },
    {
        logo: null,
        total: 5,
        c3: 1,
        cup: 1,
        subdomain: 'http://jimenezteul.localhost:4200',
        municipality: 'Jiménez del Teul',
        total_active: 0
    },
    {
        logo: null,
        total: 13,
        c3: 10,
        cup: 5,
        subdomain: 'http://juanaldama.localhost:4200',
        municipality: 'Juan Aldama',
        total_active: 0
    },
    {
        logo: null,
        total: 18,
        c3: 8,
        cup: 2,
        subdomain: 'http://juchipila.localhost:4200',
        municipality: 'Juchipila',
        total_active: 0
    },
    {
        logo: 'logos/loreto.png',
        total: 17,
        c3: 16,
        cup: 6,
        subdomain: 'http://loreto.localhost:4200',
        municipality: 'Loreto',
        total_active: 0
    },
    {
        logo: null,
        total: 6,
        c3: 5,
        cup: 0,
        subdomain: 'http://luismoya.localhost:4200',
        municipality: 'Luis Moya',
        total_active: 0
    },
    {
        logo: null,
        total: 28,
        c3: 14,
        cup: 1,
        subdomain: 'http://mazapil.localhost:4200',
        municipality: 'Mazapil',
        total_active: 0
    },
    {
        logo: null,
        total: 6,
        c3: 1,
        cup: 0,
        subdomain: 'http://melchorocampo.localhost:4200',
        municipality: 'Melchor Ocampo',
        total_active: 0
    },
    {
        logo: null,
        total: 4,
        c3: 1,
        cup: 0,
        subdomain: 'http://mezquitaloro.localhost:4200',
        municipality: 'Mezquital del Oro',
        total_active: 0
    },
    {
        logo: null,
        total: 23,
        c3: 14,
        cup: 0,
        subdomain: 'http://miguelauza.localhost:4200',
        municipality: 'Miguel Auza',
        total_active: 0
    },
    {
        logo: null,
        total: 7,
        c3: 7,
        cup: 0,
        subdomain: 'http://momax.localhost:4200',
        municipality: 'Momax',
        total_active: 0
    },
    {
        logo: null,
        total: 0,
        c3: 0,
        cup: 0,
        subdomain: 'http://monteescobedo.localhost:4200',
        municipality: 'Monte Escobedo',
        total_active: 0
    },
    {
        logo: null,
        total: 17,
        c3: 12,
        cup: 4,
        subdomain: 'http://morelos.localhost:4200',
        municipality: 'Morelos',
        total_active: 0
    },
    {
        logo: null,
        total: 10,
        c3: 5,
        cup: 0,
        subdomain: 'http://moyahuaestrada.localhost:4200',
        municipality: 'Moyahua de Estrada',
        total_active: 0
    },
    {
        logo: 'logos/nochistlanmejia.png',
        total: 64,
        c3: 37,
        cup: 18,
        subdomain: 'http://nochistlanmejia.localhost:4200',
        municipality: 'Nochistlán de Mejía',
        total_active: 0
    },
    {
        logo: null,
        total: 6,
        c3: 5,
        cup: 0,
        subdomain: 'http://noriaangeles.localhost:4200',
        municipality: 'Noria de Ángeles',
        total_active: 0
    },
    {
        logo: null,
        total: 20,
        c3: 15,
        cup: 2,
        subdomain: 'http://ojocaliente.localhost:4200',
        municipality: 'Ojocaliente',
        total_active: 0
    },
    {
        logo: null,
        total: 11,
        c3: 8,
        cup: 1,
        subdomain: 'http://panuco.localhost:4200',
        municipality: 'Pánuco',
        total_active: 0
    },
    {
        logo: 'logos/pinos.png',
        total: 3,
        c3: 1,
        cup: 0,
        subdomain: 'http://pinos.localhost:4200',
        municipality: 'Pinos',
        total_active: 0
    },
    {
        logo: 'logos/riogrande.png',
        total: 24,
        c3: 22,
        cup: 12,
        subdomain: 'http://riogrande.localhost:4200',
        municipality: 'Río Grande',
        total_active: 0
    },
    {
        logo: null,
        total: 4,
        c3: 2,
        cup: 0,
        subdomain: 'http://sainalto.localhost:4200',
        municipality: 'Sain Alto',
        total_active: 0
    },
    {
        logo: null,
        total: 5,
        c3: 5,
        cup: 2,
        subdomain: 'http://santamaria.localhost:4200',
        municipality: 'Santa María de la Paz',
        total_active: 0
    },
    {
        logo: 'logos/sombrerete.png',
        total: 52,
        c3: 33,
        cup: 13,
        subdomain: 'http://sombrerete.localhost:4200',
        municipality: 'Sombrerete',
        total_active: 0
    },
    {
        logo: null,
        total: 2,
        c3: 0,
        cup: 0,
        subdomain: 'http://susticacan.localhost:4200',
        municipality: 'Susticacán',
        total_active: 0
    },
    {
        logo: null,
        total: 7,
        c3: 7,
        cup: 5,
        subdomain: 'http://tabasco.localhost:4200',
        municipality: 'Tabasco',
        total_active: 0
    },
    {
        logo: null,
        total: 10,
        c3: 7,
        cup: 2,
        subdomain: 'http://tepechitlan.localhost:4200',
        municipality: 'Tepechitlán',
        total_active: 0
    },
    {
        logo: null,
        total: 9,
        c3: 1,
        cup: 0,
        subdomain: 'http://tepetongo.localhost:4200',
        municipality: 'Tepetongo',
        total_active: 0
    },
    {
        logo: null,
        total: 11,
        c3: 11,
        cup: 0,
        subdomain: 'http://teulgonzalez.localhost:4200',
        municipality: 'Teúl de González Ortega',
        total_active: 0
    },
    {
        logo: null,
        total: 41,
        c3: 26,
        cup: 5,
        subdomain: 'http://tlaltenangosanchez.localhost:4200',
        municipality: 'Tlaltenango de Sánchez Román',
        total_active: 0
    },
    {
        logo: null,
        total: 9,
        c3: 9,
        cup: 2,
        subdomain: 'http://trancoso.localhost:4200',
        municipality: 'Trancoso',
        total_active: 0
    },
    {
        logo: null,
        total: 5,
        c3: 4,
        cup: 0,
        subdomain: 'http://trinidadgarcia.localhost:4200',
        municipality: 'Trinidad García de la Cadena',
        total_active: 0
    },
    {
        logo: null,
        total: 33,
        c3: 20,
        cup: 12,
        subdomain: 'http://valparaiso.localhost:4200',
        municipality: 'Valparaíso',
        total_active: 0
    },
    {
        logo: null,
        total: 3,
        c3: 3,
        cup: 0,
        subdomain: 'http://vetagrande.localhost:4200',
        municipality: 'Vetagrande',
        total_active: 0
    },
    {
        logo: null,
        total: 16,
        c3: 8,
        cup: 6,
        subdomain: 'http://villacos.localhost:4200',
        municipality: 'Villa de Cos',
        total_active: 0
    },
    {
        logo: null,
        total: 4,
        c3: 1,
        cup: 0,
        subdomain: 'http://villagarcia.localhost:4200',
        municipality: 'Villa García',
        total_active: 0
    },
    {
        logo: null,
        total: 15,
        c3: 4,
        cup: 0,
        subdomain: 'http://villagonzalez.localhost:4200',
        municipality: 'Villa González Ortega',
        total_active: 0
    },
    {
        logo: null,
        total: 2,
        c3: 2,
        cup: 0,
        subdomain: 'http://villahidalgo.localhost:4200',
        municipality: 'Villa Hidalgo',
        total_active: 0
    },
    {
        logo: null,
        total: 27,
        c3: 16,
        cup: 6,
        subdomain: 'http://villanueva.localhost:4200',
        municipality: 'Villanueva',
        total_active: 0
    },
    {
        logo: 'logos/zacatecas.png',
        total: 192,
        c3: 181,
        cup: 133,
        subdomain: 'http://zacatecas.localhost:4200',
        municipality: 'Zacatecas',
        total_active: 0
    }
];

export const MUNICIPALITIES_DEV = [
    {
        logo: 'logos/apozol.jpeg',
        total: 15,
        c3: 9,
        cup: 3,
        subdomain: 'https://apozol.zacatecasymapf-qa.com',
        municipality: 'Apozol',
        total_active: 0
    },
    {
        logo: 'logos/apulco.jpeg',
        total: 0,
        c3: 0,
        cup: 0,
        subdomain: 'https://apulco.zacatecasymapf-qa.com',
        municipality: 'Apulco',
        total_active: 0
    },
    {
        logo: 'logos/atolinga.jpeg',
        total: 5,
        c3: 5,
        cup: 0,
        subdomain: 'https://atolinga.zacatecasymapf-qa.com',
        municipality: 'Atolinga',
        total_active: 0
    },
    {
        logo: 'logos/benitojuarez.jpeg',
        total: 4,
        c3: 1,
        cup: 0,
        subdomain: 'https://benitojuarez.zacatecasymapf-qa.com',
        municipality: 'Benito Juárez',
        total_active: 0
    },
    {
        logo: 'logos/calera.png',
        total: 35,
        c3: 25,
        cup: 14,
        subdomain: 'https://calera.zacatecasymapf-qa.com',
        municipality: 'Calera',
        total_active: 0
    },
    {
        logo: 'logos/canitasfelipe.jpg',
        total: 12,
        c3: 2,
        cup: 0,
        subdomain: 'https://canitasfelipe.zacatecasymapf-qa.com',
        municipality: 'Cañitas de Felipe Pescador',
        total_active: 0
    },
    {
        logo: 'logos/chalchihuites.jpeg',
        total: 8,
        c3: 7,
        cup: 0,
        subdomain: 'https://chalchihuites.zacatecasymapf-qa.com',
        municipality: 'Chalchihuites',
        total_active: 0
    },
    {
        logo: 'logos/concepcionoro.jpg',
        total: 16,
        c3: 16,
        cup: 4,
        subdomain: 'https://concepcionoro.zacatecasymapf-qa.com',
        municipality: 'Concepción del Oro',
        total_active: 0
    },
    {
        logo: 'logos/cuauhtemoc.png',
        total: 0,
        c3: 0,
        cup: 0,
        subdomain: 'https://cuauhtemoc.zacatecasymapf-qa.com',
        municipality: 'Cuauhtémoc',
        total_active: 0
    },
    {
        logo: 'logos/plateadojoaquin.jpeg',
        total: 1,
        c3: 0,
        cup: 0,
        subdomain: 'https://plateadojoaquin.zacatecasymapf-qa.com',
        municipality: 'El Plateado de Joaquín Amaro',
        total_active: 0
    },
    {
        logo: null,
        total: 7,
        c3: 2,
        cup: 0,
        subdomain: 'https://salvador.zacatecasymapf-qa.com',
        municipality: 'El Salvador',
        total_active: 0
    },
    {
        logo: 'logos/fresnillo.png',
        total: 113,
        c3: 84,
        cup: 41,
        subdomain: 'https://fresnillo.zacatecasymapf-qa.com',
        municipality: 'Fresnillo',
        total_active: 0
    },
    {
        logo: null,
        total: 4,
        c3: 3,
        cup: 1,
        subdomain: 'https://genarocodina.zacatecasymapf-qa.com',
        municipality: 'Genaro Codina',
        total_active: 0
    },
    {
        logo: null,
        total: 11,
        c3: 7,
        cup: 2,
        subdomain: 'https://enriqueestrada.zacatecasymapf-qa.com',
        municipality: 'General Enrique Estrada',
        total_active: 0
    },
    {
        logo: null,
        total: 20,
        c3: 6,
        cup: 1,
        subdomain: 'https://franciscomurguia.zacatecasymapf-qa.com',
        municipality: 'General Francisco R. Murguía',
        total_active: 0
    },
    {
        logo: null,
        total: 17,
        c3: 7,
        cup: 1,
        subdomain: 'https://panfilonatera.zacatecasymapf-qa.com',
        municipality: 'General Pánfilo Natera',
        total_active: 0
    },
    {
        logo: 'logos/guadalupe.png',
        total: 184,
        c3: 172,
        cup: 135,
        subdomain: 'https://guadalupe.zacatecasymapf-qa.com',
        municipality: 'Guadalupe',
        total_active: 0
    },
    {
        logo: null,
        total: 4,
        c3: 4,
        cup: 2,
        subdomain: 'https://huanusco.zacatecasymapf-qa.com',
        municipality: 'Huanusco',
        total_active: 0
    },
    {
        logo: null,
        total: 18,
        c3: 18,
        cup: 11,
        subdomain: 'https://jalpa.zacatecasymapf-qa.com',
        municipality: 'Jalpa',
        total_active: 0
    },
    {
        logo: 'logos/jerez.png',
        total: 71,
        c3: 63,
        cup: 27,
        subdomain: 'https://jerez.zacatecasymapf-qa.com',
        municipality: 'Jerez',
        total_active: 0
    },
    {
        logo: null,
        total: 5,
        c3: 1,
        cup: 1,
        subdomain: 'https://jimenezteul.zacatecasymapf-qa.com',
        municipality: 'Jiménez del Teul',
        total_active: 0
    },
    {
        logo: null,
        total: 13,
        c3: 10,
        cup: 5,
        subdomain: 'https://juanaldama.zacatecasymapf-qa.com',
        municipality: 'Juan Aldama',
        total_active: 0
    },
    {
        logo: null,
        total: 18,
        c3: 8,
        cup: 2,
        subdomain: 'https://juchipila.zacatecasymapf-qa.com',
        municipality: 'Juchipila',
        total_active: 0
    },
    {
        logo: 'logos/loreto.png',
        total: 17,
        c3: 16,
        cup: 6,
        subdomain: 'https://loreto.zacatecasymapf-qa.com',
        municipality: 'Loreto',
        total_active: 0
    },
    {
        logo: null,
        total: 6,
        c3: 5,
        cup: 0,
        subdomain: 'https://luismoya.zacatecasymapf-qa.com',
        municipality: 'Luis Moya',
        total_active: 0
    },
    {
        logo: null,
        total: 28,
        c3: 14,
        cup: 1,
        subdomain: 'https://mazapil.zacatecasymapf-qa.com',
        municipality: 'Mazapil',
        total_active: 0
    },
    {
        logo: null,
        total: 6,
        c3: 1,
        cup: 0,
        subdomain: 'https://melchorocampo.zacatecasymapf-qa.com',
        municipality: 'Melchor Ocampo',
        total_active: 0
    },
    {
        logo: null,
        total: 4,
        c3: 1,
        cup: 0,
        subdomain: 'https://mezquitaloro.zacatecasymapf-qa.com',
        municipality: 'Mezquital del Oro',
        total_active: 0
    },
    {
        logo: null,
        total: 23,
        c3: 14,
        cup: 0,
        subdomain: 'https://miguelauza.zacatecasymapf-qa.com',
        municipality: 'Miguel Auza',
        total_active: 0
    },
    {
        logo: null,
        total: 7,
        c3: 7,
        cup: 0,
        subdomain: 'https://momax.zacatecasymapf-qa.com',
        municipality: 'Momax',
        total_active: 0
    },
    {
        logo: null,
        total: 0,
        c3: 0,
        cup: 0,
        subdomain: 'https://monteescobedo.zacatecasymapf-qa.com',
        municipality: 'Monte Escobedo',
        total_active: 0
    },
    {
        logo: null,
        total: 17,
        c3: 12,
        cup: 4,
        subdomain: 'https://morelos.zacatecasymapf-qa.com',
        municipality: 'Morelos',
        total_active: 0
    },
    {
        logo: null,
        total: 10,
        c3: 5,
        cup: 0,
        subdomain: 'https://moyahuaestrada.zacatecasymapf-qa.com',
        municipality: 'Moyahua de Estrada',
        total_active: 0
    },
    {
        logo: 'logos/nochistlanmejia.png',
        total: 64,
        c3: 37,
        cup: 18,
        subdomain: 'https://nochistlanmejia.zacatecasymapf-qa.com',
        municipality: 'Nochistlán de Mejía',
        total_active: 0
    },
    {
        logo: null,
        total: 6,
        c3: 5,
        cup: 0,
        subdomain: 'https://noriaangeles.zacatecasymapf-qa.com',
        municipality: 'Noria de Ángeles',
        total_active: 0
    },
    {
        logo: null,
        total: 20,
        c3: 15,
        cup: 2,
        subdomain: 'https://ojocaliente.zacatecasymapf-qa.com',
        municipality: 'Ojocaliente',
        total_active: 0
    },
    {
        logo: null,
        total: 11,
        c3: 8,
        cup: 1,
        subdomain: 'https://panuco.zacatecasymapf-qa.com',
        municipality: 'Pánuco',
        total_active: 0
    },
    {
        logo: 'logos/pinos.png',
        total: 3,
        c3: 1,
        cup: 0,
        subdomain: 'https://pinos.zacatecasymapf-qa.com',
        municipality: 'Pinos',
        total_active: 0
    },
    {
        logo: 'logos/riogrande.png',
        total: 24,
        c3: 22,
        cup: 12,
        subdomain: 'https://riogrande.zacatecasymapf-qa.com',
        municipality: 'Río Grande',
        total_active: 0
    },
    {
        logo: null,
        total: 4,
        c3: 2,
        cup: 0,
        subdomain: 'https://sainalto.zacatecasymapf-qa.com',
        municipality: 'Sain Alto',
        total_active: 0
    },
    {
        logo: null,
        total: 5,
        c3: 5,
        cup: 2,
        subdomain: 'https://santamaria.zacatecasymapf-qa.com',
        municipality: 'Santa María de la Paz',
        total_active: 0
    },
    {
        logo: 'logos/sombrerete.png',
        total: 52,
        c3: 33,
        cup: 13,
        subdomain: 'https://sombrerete.zacatecasymapf-qa.com',
        municipality: 'Sombrerete',
        total_active: 0
    },
    {
        logo: null,
        total: 2,
        c3: 0,
        cup: 0,
        subdomain: 'https://susticacan.zacatecasymapf-qa.com',
        municipality: 'Susticacán',
        total_active: 0
    },
    {
        logo: null,
        total: 7,
        c3: 7,
        cup: 5,
        subdomain: 'https://tabasco.zacatecasymapf-qa.com',
        municipality: 'Tabasco',
        total_active: 0
    },
    {
        logo: null,
        total: 10,
        c3: 7,
        cup: 2,
        subdomain: 'https://tepechitlan.zacatecasymapf-qa.com',
        municipality: 'Tepechitlán',
        total_active: 0
    },
    {
        logo: null,
        total: 9,
        c3: 1,
        cup: 0,
        subdomain: 'https://tepetongo.zacatecasymapf-qa.com',
        municipality: 'Tepetongo',
        total_active: 0
    },
    {
        logo: null,
        total: 11,
        c3: 11,
        cup: 0,
        subdomain: 'https://teulgonzalez.zacatecasymapf-qa.com',
        municipality: 'Teúl de González Ortega',
        total_active: 0
    },
    {
        logo: null,
        total: 41,
        c3: 26,
        cup: 5,
        subdomain: 'https://tlaltenangosanchez.zacatecasymapf-qa.com',
        municipality: 'Tlaltenango de Sánchez Román',
        total_active: 0
    },
    {
        logo: null,
        total: 9,
        c3: 9,
        cup: 2,
        subdomain: 'https://trancoso.zacatecasymapf-qa.com',
        municipality: 'Trancoso',
        total_active: 0
    },
    {
        logo: null,
        total: 5,
        c3: 4,
        cup: 0,
        subdomain: 'https://trinidadgarcia.zacatecasymapf-qa.com',
        municipality: 'Trinidad García de la Cadena',
        total_active: 0
    },
    {
        logo: null,
        total: 33,
        c3: 20,
        cup: 12,
        subdomain: 'https://valparaiso.zacatecasymapf-qa.com',
        municipality: 'Valparaíso',
        total_active: 0
    },
    {
        logo: null,
        total: 3,
        c3: 3,
        cup: 0,
        subdomain: 'https://vetagrande.zacatecasymapf-qa.com',
        municipality: 'Vetagrande',
        total_active: 0
    },
    {
        logo: null,
        total: 16,
        c3: 8,
        cup: 6,
        subdomain: 'https://villacos.zacatecasymapf-qa.com',
        municipality: 'Villa de Cos',
        total_active: 0
    },
    {
        logo: null,
        total: 4,
        c3: 1,
        cup: 0,
        subdomain: 'https://villagarcia.zacatecasymapf-qa.com',
        municipality: 'Villa García',
        total_active: 0
    },
    {
        logo: null,
        total: 15,
        c3: 4,
        cup: 0,
        subdomain: 'https://villagonzalez.zacatecasymapf-qa.com',
        municipality: 'Villa González Ortega',
        total_active: 0
    },
    {
        logo: null,
        total: 2,
        c3: 2,
        cup: 0,
        subdomain: 'https://villahidalgo.zacatecasymapf-qa.com',
        municipality: 'Villa Hidalgo',
        total_active: 0
    },
    {
        logo: null,
        total: 27,
        c3: 16,
        cup: 6,
        subdomain: 'https://villanueva.zacatecasymapf-qa.com',
        municipality: 'Villanueva',
        total_active: 0
    },
    {
        logo: 'logos/zacatecas.png',
        total: 192,
        c3: 181,
        cup: 133,
        subdomain: 'https://zacatecas.zacatecasymapf-qa.com',
        municipality: 'Zacatecas',
        total_active: 0
    }
];

export const MUNICIPALITIES_PROD = [
    {
        logo: 'logos/apozol.jpeg',
        total: 15,
        c3: 9,
        cup: 3,
        subdomain: 'https://apozol.zacatecasymapf.com',
        municipality: 'Apozol',
        total_active: 0
    },
    {
        logo: 'logos/apulco.jpeg',
        total: 0,
        c3: 0,
        cup: 0,
        subdomain: 'https://apulco.zacatecasymapf.com',
        municipality: 'Apulco',
        total_active: 0
    },
    {
        logo: 'logos/atolinga.jpeg',
        total: 5,
        c3: 5,
        cup: 0,
        subdomain: 'https://atolinga.zacatecasymapf.com',
        municipality: 'Atolinga',
        total_active: 0
    },
    {
        logo: 'logos/benitojuarez.jpeg',
        total: 4,
        c3: 1,
        cup: 0,
        subdomain: 'https://benitojuarez.zacatecasymapf.com',
        municipality: 'Benito Juárez',
        total_active: 0
    },
    {
        logo: 'logos/calera.png',
        total: 35,
        c3: 25,
        cup: 14,
        subdomain: 'https://calera.zacatecasymapf.com',
        municipality: 'Calera',
        total_active: 0
    },
    {
        logo: 'logos/canitasfelipe.jpg',
        total: 12,
        c3: 2,
        cup: 0,
        subdomain: 'https://canitasfelipe.zacatecasymapf.com',
        municipality: 'Cañitas de Felipe Pescador',
        total_active: 0
    },
    {
        logo: 'logos/chalchihuites.jpeg',
        total: 8,
        c3: 7,
        cup: 0,
        subdomain: 'https://chalchihuites.zacatecasymapf.com',
        municipality: 'Chalchihuites',
        total_active: 0
    },
    {
        logo: 'logos/concepcionoro.jpg',
        total: 16,
        c3: 16,
        cup: 4,
        subdomain: 'https://concepcionoro.zacatecasymapf.com',
        municipality: 'Concepción del Oro',
        total_active: 0
    },
    {
        logo: 'logos/cuauhtemoc.png',
        total: 0,
        c3: 0,
        cup: 0,
        subdomain: 'https://cuauhtemoc.zacatecasymapf.com',
        municipality: 'Cuauhtémoc',
        total_active: 0
    },
    {
        logo: 'logos/plateadojoaquin.jpeg',
        total: 1,
        c3: 0,
        cup: 0,
        subdomain: 'https://plateadojoaquin.zacatecasymapf.com',
        municipality: 'El Plateado de Joaquín Amaro',
        total_active: 0
    },
    {
        logo: null,
        total: 7,
        c3: 2,
        cup: 0,
        subdomain: 'https://salvador.zacatecasymapf.com',
        municipality: 'El Salvador',
        total_active: 0
    },
    {
        logo: 'logos/fresnillo.png',
        total: 113,
        c3: 84,
        cup: 41,
        subdomain: 'https://fresnillo.zacatecasymapf.com',
        municipality: 'Fresnillo',
        total_active: 0
    },
    {
        logo: null,
        total: 4,
        c3: 3,
        cup: 1,
        subdomain: 'https://genarocodina.zacatecasymapf.com',
        municipality: 'Genaro Codina',
        total_active: 0
    },
    {
        logo: null,
        total: 11,
        c3: 7,
        cup: 2,
        subdomain: 'https://enriqueestrada.zacatecasymapf.com',
        municipality: 'General Enrique Estrada',
        total_active: 0
    },
    {
        logo: null,
        total: 20,
        c3: 6,
        cup: 1,
        subdomain: 'https://franciscomurguia.zacatecasymapf.com',
        municipality: 'General Francisco R. Murguía',
        total_active: 0
    },
    {
        logo: null,
        total: 17,
        c3: 7,
        cup: 1,
        subdomain: 'https://panfilonatera.zacatecasymapf.com',
        municipality: 'General Pánfilo Natera',
        total_active: 0
    },
    {
        logo: 'logos/guadalupe.png',
        total: 184,
        c3: 172,
        cup: 135,
        subdomain: 'https://guadalupe.zacatecasymapf.com',
        municipality: 'Guadalupe',
        total_active: 0
    },
    {
        logo: null,
        total: 4,
        c3: 4,
        cup: 2,
        subdomain: 'https://huanusco.zacatecasymapf.com',
        municipality: 'Huanusco',
        total_active: 0
    },
    {
        logo: null,
        total: 18,
        c3: 18,
        cup: 11,
        subdomain: 'https://jalpa.zacatecasymapf.com',
        municipality: 'Jalpa',
        total_active: 0
    },
    {
        logo: 'logos/jerez.png',
        total: 71,
        c3: 63,
        cup: 27,
        subdomain: 'https://jerez.zacatecasymapf.com',
        municipality: 'Jerez',
        total_active: 0
    },
    {
        logo: null,
        total: 5,
        c3: 1,
        cup: 1,
        subdomain: 'https://jimenezteul.zacatecasymapf.com',
        municipality: 'Jiménez del Teul',
        total_active: 0
    },
    {
        logo: null,
        total: 13,
        c3: 10,
        cup: 5,
        subdomain: 'https://juanaldama.zacatecasymapf.com',
        municipality: 'Juan Aldama',
        total_active: 0
    },
    {
        logo: null,
        total: 18,
        c3: 8,
        cup: 2,
        subdomain: 'https://juchipila.zacatecasymapf.com',
        municipality: 'Juchipila',
        total_active: 0
    },
    {
        logo: 'logos/loreto.png',
        total: 17,
        c3: 16,
        cup: 6,
        subdomain: 'https://loreto.zacatecasymapf.com',
        municipality: 'Loreto',
        total_active: 0
    },
    {
        logo: null,
        total: 6,
        c3: 5,
        cup: 0,
        subdomain: 'https://luismoya.zacatecasymapf.com',
        municipality: 'Luis Moya',
        total_active: 0
    },
    {
        logo: null,
        total: 28,
        c3: 14,
        cup: 1,
        subdomain: 'https://mazapil.zacatecasymapf.com',
        municipality: 'Mazapil',
        total_active: 0
    },
    {
        logo: null,
        total: 6,
        c3: 1,
        cup: 0,
        subdomain: 'https://melchorocampo.zacatecasymapf.com',
        municipality: 'Melchor Ocampo',
        total_active: 0
    },
    {
        logo: null,
        total: 4,
        c3: 1,
        cup: 0,
        subdomain: 'https://mezquitaloro.zacatecasymapf.com',
        municipality: 'Mezquital del Oro',
        total_active: 0
    },
    {
        logo: null,
        total: 23,
        c3: 14,
        cup: 0,
        subdomain: 'https://miguelauza.zacatecasymapf.com',
        municipality: 'Miguel Auza',
        total_active: 0
    },
    {
        logo: null,
        total: 7,
        c3: 7,
        cup: 0,
        subdomain: 'https://momax.zacatecasymapf.com',
        municipality: 'Momax',
        total_active: 0
    },
    {
        logo: null,
        total: 0,
        c3: 0,
        cup: 0,
        subdomain: 'https://monteescobedo.zacatecasymapf.com',
        municipality: 'Monte Escobedo',
        total_active: 0
    },
    {
        logo: null,
        total: 17,
        c3: 12,
        cup: 4,
        subdomain: 'https://morelos.zacatecasymapf.com',
        municipality: 'Morelos',
        total_active: 0
    },
    {
        logo: null,
        total: 10,
        c3: 5,
        cup: 0,
        subdomain: 'https://moyahuaestrada.zacatecasymapf.com',
        municipality: 'Moyahua de Estrada',
        total_active: 0
    },
    {
        logo: 'logos/nochistlanmejia.png',
        total: 64,
        c3: 37,
        cup: 18,
        subdomain: 'https://nochistlanmejia.zacatecasymapf.com',
        municipality: 'Nochistlán de Mejía',
        total_active: 0
    },
    {
        logo: null,
        total: 6,
        c3: 5,
        cup: 0,
        subdomain: 'https://noriaangeles.zacatecasymapf.com',
        municipality: 'Noria de Ángeles',
        total_active: 0
    },
    {
        logo: null,
        total: 20,
        c3: 15,
        cup: 2,
        subdomain: 'https://ojocaliente.zacatecasymapf.com',
        municipality: 'Ojocaliente',
        total_active: 0
    },
    {
        logo: null,
        total: 11,
        c3: 8,
        cup: 1,
        subdomain: 'https://panuco.zacatecasymapf.com',
        municipality: 'Pánuco',
        total_active: 0
    },
    {
        logo: 'logos/pinos.png',
        total: 3,
        c3: 1,
        cup: 0,
        subdomain: 'https://pinos.zacatecasymapf.com',
        municipality: 'Pinos',
        total_active: 0
    },
    {
        logo: 'logos/riogrande.png',
        total: 24,
        c3: 22,
        cup: 12,
        subdomain: 'https://riogrande.zacatecasymapf.com',
        municipality: 'Río Grande',
        total_active: 0
    },
    {
        logo: null,
        total: 4,
        c3: 2,
        cup: 0,
        subdomain: 'https://sainalto.zacatecasymapf.com',
        municipality: 'Sain Alto',
        total_active: 0
    },
    {
        logo: null,
        total: 5,
        c3: 5,
        cup: 2,
        subdomain: 'https://santamaria.zacatecasymapf.com',
        municipality: 'Santa María de la Paz',
        total_active: 0
    },
    {
        logo: 'logos/sombrerete.png',
        total: 52,
        c3: 33,
        cup: 13,
        subdomain: 'https://sombrerete.zacatecasymapf.com',
        municipality: 'Sombrerete',
        total_active: 0
    },
    {
        logo: null,
        total: 2,
        c3: 0,
        cup: 0,
        subdomain: 'https://susticacan.zacatecasymapf.com',
        municipality: 'Susticacán',
        total_active: 0
    },
    {
        logo: null,
        total: 7,
        c3: 7,
        cup: 5,
        subdomain: 'https://tabasco.zacatecasymapf.com',
        municipality: 'Tabasco',
        total_active: 0
    },
    {
        logo: null,
        total: 10,
        c3: 7,
        cup: 2,
        subdomain: 'https://tepechitlan.zacatecasymapf.com',
        municipality: 'Tepechitlán',
        total_active: 0
    },
    {
        logo: null,
        total: 9,
        c3: 1,
        cup: 0,
        subdomain: 'https://tepetongo.zacatecasymapf.com',
        municipality: 'Tepetongo',
        total_active: 0
    },
    {
        logo: null,
        total: 11,
        c3: 11,
        cup: 0,
        subdomain: 'https://teulgonzalez.zacatecasymapf.com',
        municipality: 'Teúl de González Ortega',
        total_active: 0
    },
    {
        logo: null,
        total: 41,
        c3: 26,
        cup: 5,
        subdomain: 'https://tlaltenangosanchez.zacatecasymapf.com',
        municipality: 'Tlaltenango de Sánchez Román',
        total_active: 0
    },
    {
        logo: null,
        total: 9,
        c3: 9,
        cup: 2,
        subdomain: 'https://trancoso.zacatecasymapf.com',
        municipality: 'Trancoso',
        total_active: 0
    },
    {
        logo: null,
        total: 5,
        c3: 4,
        cup: 0,
        subdomain: 'https://trinidadgarcia.zacatecasymapf.com',
        municipality: 'Trinidad García de la Cadena',
        total_active: 0
    },
    {
        logo: null,
        total: 33,
        c3: 20,
        cup: 12,
        subdomain: 'https://valparaiso.zacatecasymapf.com',
        municipality: 'Valparaíso',
        total_active: 0
    },
    {
        logo: null,
        total: 3,
        c3: 3,
        cup: 0,
        subdomain: 'https://vetagrande.zacatecasymapf.com',
        municipality: 'Vetagrande',
        total_active: 0
    },
    {
        logo: null,
        total: 16,
        c3: 8,
        cup: 6,
        subdomain: 'https://villacos.zacatecasymapf.com',
        municipality: 'Villa de Cos',
        total_active: 0
    },
    {
        logo: null,
        total: 4,
        c3: 1,
        cup: 0,
        subdomain: 'https://villagarcia.zacatecasymapf.com',
        municipality: 'Villa García',
        total_active: 0
    },
    {
        logo: null,
        total: 15,
        c3: 4,
        cup: 0,
        subdomain: 'https://villagonzalez.zacatecasymapf.com',
        municipality: 'Villa González Ortega',
        total_active: 0
    },
    {
        logo: null,
        total: 2,
        c3: 2,
        cup: 0,
        subdomain: 'https://villahidalgo.zacatecasymapf.com',
        municipality: 'Villa Hidalgo',
        total_active: 0
    },
    {
        logo: null,
        total: 27,
        c3: 16,
        cup: 6,
        subdomain: 'https://villanueva.zacatecasymapf.com',
        municipality: 'Villanueva',
        total_active: 0
    },
    {
        logo: 'logos/zacatecas.png',
        total: 192,
        c3: 181,
        cup: 133,
        subdomain: 'https://zacatecas.zacatecasymapf.com',
        municipality: 'Zacatecas',
        total_active: 0
    }
];

export const C3_CAT = [
    'Acreditado',
    'No Acreditado',
    'Sin Evaluación'
];

export const CUP_CAT = [
    'Certificado',
    'No Certificado',
    'En proceso de certificación'
]